import { render, staticRenderFns } from "./deptList.vue?vue&type=template&id=70bc8cd8&"
import script from "./deptList.vue?vue&type=script&lang=js&"
export * from "./deptList.vue?vue&type=script&lang=js&"
import style0 from "./deptList.vue?vue&type=style&index=0&id=70bc8cd8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports